export default {
  EVENT_SETTINGS_UPDATED: 'Event settings has been updated successfully!',
  DAILY_REPORTS_ENABLED: 'Daily Reports Enabled',
  EVENT_SETTINGS: 'Event Settings',
  ARCHIVAL_DAYS: 'Archival Days',
  EVENT_ARCHIVAL_DATE: 'The event will archive on '
}
